import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

/**
 * Roman numeral chapter watermark. Sits BEHIND text.
 * Sized via viewport width so it stays big on desktop but tucks in on mobile.
 */
export default function ChapterMark({
  numeral,
  label,
  align = "left",
  color = "hsl(var(--earth))",
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <div
      ref={ref}
      aria-hidden
      className="pointer-events-none absolute inset-0 -z-0 overflow-hidden"
    >
      <motion.div
        style={{ y }}
        className={[
          "absolute top-[6%] chapter-mark",
          align === "left"
            ? "left-[-2vw] md:left-[-3vw]"
            : "right-[-2vw] md:right-[-3vw]",
        ].join(" ")}
      >
        <div
          className="font-display text-[26vw] md:text-[18vw] leading-none"
          style={{ color, opacity: 0.06 }}
        >
          {numeral}
        </div>
        {label && (
          <div
            className={[
              "mt-2 font-body uppercase tracking-[0.4em] text-xs md:text-sm",
              // The numeral above is meant to bleed off the edge; counter-pad the LABEL back
              // on-screen so it isn't clipped (fixes the left/right cut-off on every chapter).
              align === "left"
                ? "pl-[3vw] md:pl-[4vw]"
                : "pr-[3vw] md:pr-[4vw] text-right",
            ].join(" ")}
            style={{ color, opacity: 0.35 }}
          >
            {label}
          </div>
        )}
      </motion.div>
    </div>
  );
}
